export const TypeMetaDataEnum = Object.freeze({
    article: "article",
    link: "link",
    popup: "popup",
    videoLink: "videoLink",
    videoEmbed: "videoEmbed",
    vr360: "vr360"
})